
import { GlobalController } from 'src/shared/global/GlobalController'
import VehicleComponentGroup from './VehicleComponentGroup'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'vehicleComponentGroup',
    component: VehicleComponentGroup,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
